import React, { ReactNode } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { PlayPauseButton } from "./PlayPauseButton";

type TimelinePlayerProps = {
  isPlaying: boolean;
  onTogglePlayPause: () => void;
  children: ReactNode;
  productAnalyticsEvent: () => void;
};

export const TimelinePlayer: React.FC<TimelinePlayerProps> = ({
  isPlaying,
  onTogglePlayPause,
  children,
  productAnalyticsEvent,
}) => {
  return (
    <Flex
      flexDirection="column"
      w={{
        base: "100%",
        sm: "400px",
        md: "450px",
        lg: "500px",
        xl: "600px",
        "2xl": "800px",
      }}
      h="52px"
      bg="rgba(0, 0, 0, 0.4)"
      borderRadius="md"
      justifyContent="center"
      px={{ base: 2, sm: 3, md: 4 }}
    >
      <Flex alignItems="center" gap={2} w="100%">
        <PlayPauseButton
          isPlaying={isPlaying}
          onToggle={() => {
            onTogglePlayPause();
            if (!isPlaying) {
              productAnalyticsEvent();
            }
          }}
        />
        <Box w="100%">{children}</Box>
      </Flex>
    </Flex>
  );
};
